import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'Attributes',
        caption: 'Attributes',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        fixed: false,
        allowEditing: false,
        allowSorting: false,
    },
    {
        dataField: 'Details',
        caption: 'Details',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        fixed: false,
        allowEditing: false,
        allowSorting: false,
    },
];

export const dataSource = [
    {
        Attributes: 'Registration',
        Details: '1244HO87',
    },
    {
        Attributes: 'State',
        Details: 'QLD',
    },
    {
        Attributes: 'Vehicle Make',
        Details: 'Toyota',
    },
    {
        Attributes: 'Year',
        Details: '2025',
    },
    {
        Attributes: 'VIN',
        Details: '1HGBH41JXMN109186',
    },
    {
        Attributes: 'Chassis',
        Details: 'ASD1234567',
    },
    {
        Attributes: 'Engine No',
        Details: 'ENG1234567',
    },
    {
        Attributes: 'Body Style',
        Details: 'Sedan',
    },
    {
        Attributes: 'CC Rating',
        Details: '2500',
    },
    {
        Attributes: 'Country of Origin',
        Details: 'New Plate - QLD',
    },
  ];
